function PageHeader(props) {
    return(
        <section>
            <h1 className="page-header">{ props.title }</h1>
        </section>
    );
}

export default PageHeader;